import { useState, useRef } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../Context/LanguageContext';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

export default function ProductCountInput(props) {
	const { value, setValue, changeFn, placeholder, width, disabled } = props;
	const { t } = useLanguage();
	const { isDark } = useTheme();
	const theme = isDark ? darkTheme : lightTheme;

	const [clickCount, setClickCount] = useState(0);

	const inputRef = useRef();

	function handleClick(e) {
		inputRef.current.style.borderColor = theme.primary;
	}

	function handleChange(e) {
    setValue(e.target.value);
	}

	function handleFocus(e) {
	}

	function handleBlur(e) {
		setClickCount(clickCount + 1);
		inputRef.current.style.borderColor = theme.line;
	}

	return (
    <TopLevelWrapper>
      <Input
        ref={inputRef}
        disabled={disabled}
        $isDark={isDark}
        width={width}
        clickCount={clickCount}
        placeholder={placeholder}
        value={value || ""}
        onClick={handleClick}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur} />
        <Text>{t('memberDetail.productSalesModal.productSalesPieceUnit')}</Text>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

	margin-top: 8px;
`;

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 20px;

  	width: 100%;
	height: 35px;

	padding: 0 8px 0 8px;

	outline: none;
	border: 1px solid ${props => props.disabled ? props.theme.subBackground : props.theme.line};
	border-radius: 5px;
	color: ${props => props.theme.text};
  	background-color: ${props => props.theme.subBackground};

	::placeholder {
		color: ${props => props.theme.gray};
	}

  transition: all 0.3s ease-in-out;
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.text};

  margin: 0px 0px 0px 5px;
`;
